import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Menus from "@/pages/Menus";
import Location from "@/pages/Location";
import Reservation from "@/pages/Reservation";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminShell from "@/pages/AdminShell";
import AdminMenus from "@/pages/AdminMenus";
import AdminHero from "@/pages/AdminHero";
import AdminContent from "@/pages/AdminContent";
import AdminReservations from "@/pages/AdminReservations";
import AdminMessages from "@/pages/AdminMessages";
import AdminSettings from "@/pages/AdminSettings";
import AdminUsers from "@/pages/AdminUsers";
import AdminChangelog from "@/pages/AdminChangelog";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/menus" element={<Menus />} />
              <Route path="/location" element={<Location />} />
              <Route path="/reservation" element={<Reservation />} />
              <Route path="/contact" element={<Contact />} />
            </Route>

            {/* Admin — no public link */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminShell />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="menus" replace />} />
              <Route path="menus" element={<AdminMenus />} />
              <Route path="hero" element={<AdminHero />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="reservations" element={<AdminReservations />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="changelog" element={<AdminChangelog />} />
              <Route
                path="users"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminUsers />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </SettingsProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "hsl(30 11% 7%)",
            color: "hsl(40 20% 90%)",
            border: "1px solid hsl(30 11% 15%)",
            borderRadius: "2px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
